import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading'
import vSelect from 'vue-select'

export default {
	name: 'activitylist',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
		DatePicker,
		Multiselect,
   VueElementLoading,
	 vSelect
	},

	data: function() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listActivitytypeData: [],
			listActivitydata: [],
			addboxemodal: false,
			id: '',
			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',
			warehousesearch: '',
			boxid:'',

			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',

			assignee:'',
			userListData:'',
			description:'',
			activitytypesearch:'',
			startdate:'',
			enddate:'',
			rackids:[],
			activityid:'',
			showaddcyclecount:false,
			listRackData: [],
			accordianTab: {
				1: true,
				2: false,
			},
			expanded: false,
			ActivityErr:'',
			showaddcycle:false,
			startdateErr:'',
			enddateErr:'',
      descriptionErr:'',
			rackidsErr:'',
			pickerid:'',
			rowData:[],
			rackid:'',
			assignee:'',
			currentDate: '',

		}
	},

	created: function() {},
	// when a page loads,mounted() will be call
	filters: {
		moment: function(dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;

		this.pageno = 0;

		this.reportname = this.$t('activities.boxTypeReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.getActivityypeData();
		this.getUesrsList();
		this.getRackData();
		switch (this.user_type) {
			case 'system_user':
			this.loginUserEmail =userdetail.email;
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				//this.getWarehouseList();
				break;

			case 'client_user':
			this.loginUserEmail =userdetail.email;
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
		this.calldateFunction();

	},
	methods: {
		calldateFunction() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate());
			//this.enddate = this.currentDate;
			//this.startdate = dt;

		},
		showList() {
			this.$emit("goBackToParent")
		},
		expandAll() {
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll() {
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid) {
			for (var key in this.accordianTab) {
				if (tabid != key) {
					this.accordianTab[key] = false;
				}
			}
		},
     AddRacks(){
			 this.rackidsErr = "";
			 if (this.rackids.length == 0) {
 				this.rackidsErr = "Rackids is required";
 				this.pageNo = this.totalPage = 0;
 				return false;
 			}
			var usermail  = ''
			//console.log(this.userListData);
 			if(this.userListData){
				if(this.pickerid){
					let userdata = this.userListData.filter(obj => obj.userid == this.pickerid);
				  usermail = userdata[0].email
				}
 			}
			this.userListData = this.userListData.filter(obj => obj.userid != this.pickerid)

			 var my_object = {
				  racks:this.rackids.toString(),
			    assignee:usermail,
					userid:this.pickerid
        };
      this.rowData.push(my_object)
			 let racks = this.rackids.toString();
			 let rackids = racks.split(",");
			 for(let i=0;i<rackids.length;i++){
				  this.listRackData.splice(this.listRackData.indexOf(rackids[i]),1)
			}
      this.racks = '';
      this.assignee = '';
			this.rackids = '';
      this.pickerid = '';
		},
		async RemoveRacks(index,racks,userid,email){
		 this.rowData.splice(index,1);
		 let rackids = racks.split(",");
     for(let i=0;i<rackids.length;i++){
			 this.listRackData.push(rackids[i])
		 }
		 this.userListData.push({
			 userid:userid,
			 email:email
		 })
	 },
		////////
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'warehouseid': this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected(type) {
		// 	this.warehousesearch = '';
		// 	if (type == 'list') {
		// 		this.clientid = this.clientsearch;
		// 		if (this.clientid) {
		// 			if (!this.warehouseid) {
		// 				this.getWarehouseList();
		// 			} else {
		// 				if (this.user_type == 'warehouse_user') {
		// 					this.warehousesearch = this.warehouseid;
		// 					this.getActivityypeData();
		// 					this.getUesrsList();
		// 				}
		// 				this.getRackData();
		// 			}
		// 		}
		// 	} else {
		// 		this.clientid = this.client;
		// 			this.getWarehouseList();
		// 		this.getActivityypeData();

		// 	}
		// },

		// warehouseSelected(type) {
		// 	if (type == 'list') {
		// 		this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();
		// 				this.getUesrsList();
		// 				this.getRackData();

		// 			} else {
		// 				this.getActivityypeData();
		// 				this.getUesrsList();
		// 				this.getRackData();
		// 			}
		// 		}
		// 	} else {
		// 		this.warehouseid = this.warehouse;
		// 		this.getActivityypeData();
		// 		this.getRackData();

		// 	}
		// },
		// this function for pagination
		getActivityypeData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = {
				clientid: this.clientid,
			};

			if (this.clientid) {
				// this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getActivityMaster',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listActivitytypeData = result.data.data;
						this.isLoading = false;
					}, error => {
						console.error(error);
					})
			} else {
				this.listActivitytypeData = [];
				//	this.ClientErr = 'Client is required';
			}
		},
		getRackData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
     this.listRackData = []

			this.input = {
				clientid: Number(this.clientid),
				warehouseid:window.localStorage.getItem('selectedWarehouse'),
				searchstring:''
			};

			if (this.clientid) {
				// this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'searchCycyleCountRack',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (result.data.status) {
	            for (var i = 0; i < result.data.data.length; i++) {
	              this.listRackData.push(result.data.data[i].rackno);
	            }
	          }
						this.isLoading = false;
					}, error => {
						console.error(error);
					})
			} else {
				this.listActivitytypeData = [];
			}
		},

		async getUesrsList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.userListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
    SaveActivity(){
			this.ClientErrr = '';
			this.WarehouseErr = '';
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error('Please Select Client')
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error('Please Select Warehouse')
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.activitytypesearch == '') {
				this.ActivityErr =  this.$t('activities.activitypeError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.startdate == '') {
				this.startdateErr = this.$t('common.estimatedStartDateError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.startdate >=  this.enddate) {
				this.enddateErr = this.$t('common.estimatedDateErrormsg');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.enddate == '') {
				this.enddateErr = this.$t('common.estimatedEndDateError');
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (this.rowData.length == 0 && this.rackids.length == 0) {
				this.rackidsErr = this.$t('common.rackidErrorMsg');
				this.pageNo = this.totalPage = 0;
				return false;
			}

      var activityname = ''
			if(this.listActivitytypeData){
				activityname = this.listActivitytypeData.filter(obj => obj.id == this.activitytypesearch);
			}
			let racks = [];
			for (let x = 0; x < this.rowData.length; x++) {
				let rackids = this.rowData[x].racks.split(",");
				for(let y =0;y < rackids.length; y++){
					racks.push({
					 rackid: rackids[y],
					 userid:this.rowData[x].userid,
					 assignto:this.rowData[x].assignee,
				 });
				}
			}
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				activityname:activityname[0].activityname,
				activitytypeid: this.activitytypesearch,
				estartdate:this.startdate,
				eenddate:this.enddate,
				createdby: this.loginUserEmail,
				description: this.description,
				tasklist:racks,
			})
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'createActivity',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then((response) => {
					if (response.data.ErrorCode == 0) {
						this.isLoading = false
						this.$alertify.success("Activity Created Successfully")
						//this.$router.push('/cyclecount');
						this.iserror = false;
						this.input = ({
							clientid: window.localStorage.getItem('selectedClient'),
							warehouseid: window.localStorage.getItem('selectedWarehouse'),
							activitytypeid: this.activitytypesearch,
							taskid:response.data.data.activitydetailsid
						})
						this.$emit("goBackToParent",this.input)
						this.geActivitydata();
					} else {
						this.isLoading = false
						this.$alertify.error("Some error/Invalid data")
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})

		},
		NextActivity(){
			this.ClientErr = '';
			this.WarehouseErr = '';
			this.enddateErr = '';
			this.ActivityErr = '';
			this.startdateErr = '';
			this.descriptionErr = "";

			if (this.clientid == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.warehouseid == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.activitytypesearch == '') {
				this.ActivityErr =  this.$t('activities.activitypeError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.startdate == '') {
				this.startdateErr = this.$t('common.estimatedStartDateError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.enddate == '') {
				this.enddateErr = this.$t('common.estimatedDateErrormsg');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.startdate >=  this.enddate) {
				this.enddateErr = this.$t('common.estimatedDateErrormsg');
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if(this.activitytypesearch == 1 ){
				this.showaddcycle = true;
				this.accordianTab[2] =true;
			}
		},
		resetaddForm() {
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.totalPage = 0;
			this.listActivitytypeData = [];
			this.activitytypesearch = '';
			this.description = '';
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.rackids =[];
			this.startdate = '';
			this.enddate = '';
			this.ActivityErr ='';
			this.startdateErr ='';
      this.enddateErr = '';
			this.rowData = [];
				this.showaddcycle = false;
			if (this.user_type == 'warehouse_user') {
				this.clientid = '';
			} else if (this.user_type == 'client_user') {
				this.warehouseid = '';
			} else {
				this.clientid = '';
				this.warehouse = '';
				this.warehouseid = '';
			}
		},
		dateFormat(date, type) {
			if (!date) return '';

			if (type == 1) {
				return moment(date).format('YYYY-MM-DD 00:00:00');
			} else {
				return moment(date).format('YYYY-MM-DD 23:59:00');
			}
		},
		geActivitydata(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			// var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.currentPage = 1;
				this.contentVisible = false;
				this.listingtype = "planlisting"
				this.id = ""
			}

			if (this.clientid == '') {
				this.ClientErr = 'Client is required';
				this.pageno = this.pageCount = 0;
				this.listActivitydata = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageno = this.pageCount = 0;
				this.listActivitydata = [];
				return false;
			}
			var fromDateFlt = '';
			var toDateFlt = '';
			var value = '';
			var str = '';
			this.dataFilter = {}

			if (this.fromDateFlt != "") {
				fromDateFlt = this.dateFormat(this.fromDateFlt, 1);
			}
			if (this.toDateFlt != "") {
				toDateFlt = this.dateFormat(this.toDateFlt, 2);
			}
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				offset: (this.currentPage - 1) * this.pageLimit,
				limit: this.pageLimit,
				activitystatus: this.searchstatus,
				listingtype: this.listingtype,
				activitytypeid: this.activitytypesearch,
				fromdate: fromDateFlt,
				todate: toDateFlt,
				assignedto: this.assignee,
				csvData: csvCheck,
				id: this.id
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData', 'listingtype'];

				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					if (csvCheck == 3) {
						value += k + ':' + v + ','
						this.dataFilter1 = str.concat(value);
					}
					else {
						this.dataFilter[k] = v;
					}
				}
			})
			if (this.clientid && this.warehouseid) {
				this.isLoading = true;
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getActivityList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (result.data.data.length > 0 && csvCheck == 1) {
							this.show = true;
							this.download = false;
							this.csvFields = {
								'activityname': this.$t('activities.activityname'),
								'createddate': this.$t('common.createdDate'),
								'rackid': this.$t('warehouseRacks.rackId'),
								'taskstatus': this.$t('activities.taskStatus'),
								'userid': this.$t('loginUsers.userId'),
								'activitystatus': this.$t('activities.activityStatus'),
								'activitydetailsid': this.$t('activities.activityid'),
								'eenddate': this.$t('activities.estimatedEndDate'),
								'estartdate': this.$t('activities.estimatedStartDate'),
							};
							var dateFilter = [];
							var skipFilter = [];

							csvHelper.data.jsonToCSV(this.$t('activities.activityListReport'), result.data.data, this.csvFields, dateFilter, skipFilter, this.dataFilter);
							this.isLoading = false;
							return true;
						} else if (result.data.data.length > 0 && csvCheck == 3) {
							this.show = true;
							this.download = false;
							this.csvFieldsForXls[this.$t('activities.activityname')]='activityname',
							this.csvFieldsForXls[this.$t('activities.activityid')]='activitydetailsid',
							this.csvFieldsForXls[this.$t('common.createdDate')]='activityname',
							this.csvFieldsForXls[this.$t('warehouseRacks.rackId')]='rackid',
							this.csvFieldsForXls[this.$t('loginUsers.userId')]='userid',
							this.csvFieldsForXls[this.$t('activities.taskStatus')]='taskstatus',
							this.csvFieldsForXls[this.$t('activities.activityStatus')]='activitystatus',
							this.csvFieldsForXls[this.$t('activities.estimatedEndDate')]='estartdate',
							this.csvFieldsForXls[this.$t('activities.estimatedStartDate')]='eenddate',
							this.ActivityListXls = result.data.data
							this.isLoading = false;
							return true;
						}
						if (this.listingtype == 'planlisting' && result.data.data.length > 0) {
							this.listActivitydata = result.data.data;
							this.resultCount = result.data.data[0].rowcount;
							this.totalRows = Number(result.data.data[0].rowcount);
							this.setPageCounts(result.data.data[0].rowcount);
						}
						else if (this.listingtype == 'planlisting' && result.data.data.length == 0) {
							this.totalRows = 0
							this.totalRows = 0;
							this.listActivitydata = []
						}
						else {
							this.tasklisting = result.data.data;
						}
						this.isLoading = false;
						this.searchFlag = true
					}, error => {
						console.error(error);
					})
			} else {
				this.listActivitydata = [];
				this.resultCount = 0;
				this.setPageCounts(0);

				if (!this.clientid) {
					this.ClientErr = 'Client is required';
				}
				if (!this.warehouseid) {
					this.ClientErr = 'Warehouse is required';
				}
			}
		},
		onSubmit: function(e) {
			this.$validator
				.validateAll()
				.then((result) => {
					if (result) {
						console.log("form is valid", this.model);
						event.target.reset();
					} else {
						return false;
					}

				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/activitylist/addactivity.component.js